(function () {
	const settings = {
		numberInput: {
			selector: '.number',
			selectorControl: '.number__control',
			selectorDownButton: '.number__down',
			selectorUpButton: '.number__up'
		},
		auth: {
			selectorLoginButton: '.sys__login-button',
			userAuthenticatedCssClass: 'top-toolbar__login-button--authenticated',
			selectorChatButton: '.sys__chat-button',
			selectorNotAuthUser: '.sys__not-auth-user',
			chatButtonActiveCssClass: 'bottom-sticky-panel__button--active',
		},
		menu: {
			selectorRoot: '.sys__root',
			selectorSandwich: '.sys__sandwich',
			classMenuOpened: 'sys__root--menu-opened'
		},
		serviceRate: {
			selectorRateWrapper: '.sys__service-rate-wrapper',
			selectorRateContainer: '.sys__service-rate-container',
			rateReceivedCssClass: 'service-rate--received',
		},
		cookiesAlert: {
			localStorageKeyAccepted: 'i_love_cookies',
			cssClassAlertVisible: 'cookie-agree--visible',
			selectorCookiesAlert: '.sys__cookie-alert',
			selectorCookiesAccept: '.sys__cookie-accept-action'
		},
		popupAlert: {
			localStorageKeyAccepted: 'F4572B5B-F08F-45A9-9C3B-784940EEC613',
			cssClassPopupVisible: 'popup--active',
			selectorPopupContainer: '.sys__popup-container',
			selectorPopup: '.sys__popup',
			selectorPopupCloseButton: '.sys__popup-close',
			selectorPopupOverlay: '.sys__popup-overlay',
			expirationDate: new Date(2000, 1, 20)
		}
	};
	const storedName = localStorage['user_short_name'];
	const authenticated = !!storedName;

	function initAuthState() {
		if (authenticated) {
			if (storedName.length > 0) {
				const loginButton = document.querySelector(settings.auth.selectorLoginButton);
				loginButton.innerText = storedName[0];
				loginButton.setAttribute('title', storedName);
				loginButton.classList.add(settings.auth.userAuthenticatedCssClass);
			}
			document.querySelector(settings.auth.selectorChatButton).classList.add(settings.auth.chatButtonActiveCssClass)
		}
		
		if (!authenticated) {
			for (let element of document.querySelectorAll(settings.auth.selectorNotAuthUser)) {
				element.style.removeProperty('display'); //remove display: none;
			}
		}
	}

	function initBurgerMenu() {
		const root = document.querySelector(settings.menu.selectorRoot);
		const sandwich = document.querySelector(settings.menu.selectorSandwich);
		sandwich.addEventListener('click', function () {
			root.classList.toggle(settings.menu.classMenuOpened);
		});
	}

	function initScrollToTop() {
		const button = document.querySelector('.sys__scroll-to-top');

		button.addEventListener('click', () => {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		})
		
		function toggleActiveClass() {
			button.classList.toggle('bottom-sticky-panel__button-scroll--active', window.scrollY > 200);
		}

		toggleActiveClass();
		window.addEventListener('scroll', () => toggleActiveClass())
	}

	function initCookiesAlert() {
		if (authenticated || !!localStorage[settings.cookiesAlert.localStorageKeyAccepted]) {
			return;
		}
		const alertNode = document.querySelector(settings.cookiesAlert.selectorCookiesAlert);
		alertNode.classList.add(settings.cookiesAlert.cssClassAlertVisible);
		const acceptButton = document.querySelector(settings.cookiesAlert.selectorCookiesAccept);
		acceptButton.addEventListener('click', (e) => {
			localStorage[settings.cookiesAlert.localStorageKeyAccepted] = true;
			alertNode.classList.remove(settings.cookiesAlert.cssClassAlertVisible);
		});
	}

	function initNumberInputs() {
		function newValue(controlValue, value) {
			return Math.round(((parseFloat(controlValue) || 0) + value) * 100) / 100;
		}

		for (let numberNode of document.querySelectorAll(settings.numberInput.selector)) {
			const controlNode = numberNode.querySelector(settings.numberInput.selectorControl);
			const downButton = numberNode.querySelector(settings.numberInput.selectorDownButton);
			const upButton = numberNode.querySelector(settings.numberInput.selectorUpButton);
			const step = parseFloat(controlNode.step) || 0.1;
			const minValue = parseFloat(controlNode.min);
			const maxValue = parseFloat(controlNode.max);

			function isMinValue(value) {
				return !isNaN(minValue) && value <= minValue;
			}

			function isMaxValue(value) {
				return !isNaN(maxValue) && value >= maxValue;
			}

			function clickEvent(addValue) {
				const value = newValue(controlNode.value, addValue);
				controlNode.value = isMinValue(value) ? minValue : isMaxValue(value) ? maxValue : value
				controlNode.dispatchEvent(new Event('input'));
			}

			controlNode.addEventListener('input', function () {
				downButton.toggleAttribute('disabled', isMinValue(parseFloat(controlNode.value)));
				upButton.toggleAttribute('disabled', isMaxValue(parseFloat(controlNode.value)));
			});

			upButton.addEventListener('click', function () {
				clickEvent(step);
			});
			downButton.addEventListener('click', function () {
				clickEvent(-1 * step);
			});
		}
	}

	function createRateNode(text) {
		const result = document.createElement('span');
		result.className = 'service-rate__text service-rate__text--highlight';
		result.innerText = text;
		return result;
	}

	function initServiceRate() {
		const serviceRateWrapper = document.querySelector(settings.serviceRate.selectorRateWrapper);
		const serviceRateContainer = document.querySelector(settings.serviceRate.selectorRateContainer);

		fetch('https://kupishop.eleview.com/api/pg/ExchangeRate')
			.then(response =>
				response.json().then(result => {
					serviceRateContainer.appendChild(createRateNode(`1 EUR = ${result.eurToRub.toFixed(4)} RUB`))
					serviceRateContainer.appendChild(createRateNode(`1 USD = ${result.usdToRub.toFixed(4)} RUB`))
					serviceRateContainer.appendChild(createRateNode(`1 CNY = ${result.cnyToRub.toFixed(4)} RUB`))
					serviceRateWrapper.classList.add(settings.serviceRate.rateReceivedCssClass);
				})
			)
	}

	function initPopup() {
		function fetchPopup () {
			const random = Math.floor(Math.random() * 10000000000000000);
			return new Promise((resolve, reject) => {
				fetch(`/chunks/popup.html?${random}`)
					.then(response => response.text()
						.then(resolve)
						.catch(reject)
					)
					.catch(reject);
			});
		}

		if (!!localStorage[settings.popupAlert.localStorageKeyAccepted] || new Date(Date.now()) >= settings.popupAlert.expirationDate) {
			return;
		}

		fetchPopup().then(popupHTML => {
			const popupContainer = document.querySelector(settings.popupAlert.selectorPopupContainer); 
			popupContainer.innerHTML += popupHTML;

			localStorage[settings.popupAlert.localStorageKeyAccepted] = true;

			const popupNode = popupContainer.querySelector(settings.popupAlert.selectorPopup);

			popupContainer.querySelector(settings.popupAlert.selectorPopupOverlay).addEventListener('click', () => {
				popupNode.classList.remove(settings.popupAlert.cssClassPopupVisible);
			})

			popupContainer.querySelectorAll(settings.popupAlert.selectorPopupCloseButton).forEach(btn => {
				btn.addEventListener('click', () => {
					popupNode.classList.remove(settings.popupAlert.cssClassPopupVisible);
				})
			});
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAuthState();
		initBurgerMenu();
		initScrollToTop();
		initCookiesAlert();
		initNumberInputs();
		initServiceRate();
		initPopup(); 
	});
})();
